import React, { useMemo } from 'react';

const GuestAnalytics = ({ passes }) => {
  const stats = useMemo(() => {
    const total = passes.length;
    const arrived = passes.filter(p => p.status === 'used').length;
    const withLinkedin = passes.filter(p => p.linkedinId && p.linkedinId.trim() !== '').length;
    
    // Assuming 'India' is the default domestic country. We can adjust this if needed.
    const international = passes.filter(p => p.country && p.country.toLowerCase() !== 'india' && p.country.toLowerCase() !== 'in').length;

    const countryMap = {};
    passes.forEach(p => {
      const c = p.country || 'Unknown';
      countryMap[c] = (countryMap[c] || 0) + 1;
    });

    const countries = Object.entries(countryMap).sort((a, b) => b[1] - a[1]);

    return { total, arrived, withLinkedin, international, countries };
  }, [passes]);

  const Card = ({ title, value, subtitle }) => (
    <div style={{ 
      background: 'var(--surface-1)', 
      padding: '24px', 
      borderRadius: '12px', 
      border: '1px solid var(--border)',
      boxShadow: 'var(--shadow-sm)',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    }}>
      <div style={{ color: 'var(--text-2)', fontSize: '0.9rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{title}</div>
      <div style={{ fontSize: '2.5rem', fontWeight: 700, color: 'var(--text-1)' }}>{value}</div>
      {subtitle && <div style={{ color: 'var(--text-3)', fontSize: '0.85rem' }}>{subtitle}</div>}
    </div>
  );

  return (
    <div>
      <h2 style={{ marginBottom: '1.5rem' }}>Guest Analytics Overview</h2>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '2rem' }}>
        <Card title="Total Guests" value={stats.total} subtitle="All time invited" />
        <Card title="Arrived" value={stats.arrived} subtitle={`${stats.total > 0 ? Math.round((stats.arrived / stats.total) * 100) : 0}% attendance rate`} />
        <Card title="With LinkedIn" value={stats.withLinkedin} subtitle={`${stats.total > 0 ? Math.round((stats.withLinkedin / stats.total) * 100) : 0}% of total guests`} />
        <Card title="International" value={stats.international} subtitle="Guests from outside India" />
      </div>

      <div style={{ background: 'var(--surface-1)', padding: '24px', borderRadius: '12px', border: '1px solid var(--border)' }}>
        <h3 style={{ marginTop: 0, marginBottom: '1rem', color: 'var(--text-1)' }}>Guests by Country</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px' }}>
          {stats.countries.map(([country, count]) => (
            <div key={country} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px', background: 'var(--surface-2)', borderRadius: '8px' }}>
              <span style={{ fontWeight: 500, color: 'var(--text-2)' }}>{country}</span>
              <span style={{ fontWeight: 700, color: 'var(--text-1)' }}>{count}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GuestAnalytics;
